module.exports = __webpack_public_path__ + "media/bootstrap-icons/cart-check-fill-434c43c7.svg";